//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import React, { useEffect } from 'react';

import { useSmartInputContext } from '@components/molecules/smart-input/SmartInputContext';
import { getCurrentCursorPosition } from '@components/molecules/smart-input/mentions/mentionsUtils';
import {
  IDraftDecoratorComponentProps,
  IMentionsSuggestionsQuery,
} from '@components/molecules/smart-input/smartInputModel';

interface Props extends IDraftDecoratorComponentProps {
  children: React.ReactNode;
}

export const Mention = ({
  blockKey,
  children,
  decoratedText,
  end,
  start,
}: Props) => {
  const smartInputContext = useSmartInputContext();

  // When the query changes and the cursor is within this mention, set the query and open the suggestions dropdown
  useEffect(() => {
    const editorState = smartInputContext.editor.getEditorState();
    const { currentBlockKey, cursorIndex } =
      getCurrentCursorPosition(editorState);

    if (
      currentBlockKey === blockKey &&
      cursorIndex >= start &&
      cursorIndex <= end
    ) {
      // Slice off the `@` that we know will be there because it is required to render this component
      const decoratedTextWithoutPrefix = decoratedText.slice(1);
      const query: IMentionsSuggestionsQuery = {
        blockKey,
        start,
        end,
        queryString: decoratedTextWithoutPrefix,
      };
      smartInputContext.mentions?.setMentionsSuggestionsQuery(query);
      smartInputContext.mentions?.setIsDropdownOpen(true, true);
    }
  }, [decoratedText]);

  return <>{children}</>;
};
